export default __webpack_public_path__ + "static/media/Samir Kharratt.d17e164a.jpg";